export const DEFAULT_SELECTED_HEADERS_LOWERCASED = ['id', 'key', 'name', 'title'].map((key) => key.toLowerCase()); // keep lowercase
